import { supabase } from "@/integrations/supabase/client";

export interface PublicImageHotspot {
  id: string;
  scope: string;
  scope_id: string;
  x_pct: number;
  y_pct: number;
  title_ar: string | null;
  title_en: string | null;
  body_ar: string | null;
  body_en: string | null;
  image_url: string | null;
  link_url: string | null;
  sort_order: number;
}

export async function fetchPublicImageHotspots(scope: string, scopeId: string) {
  const { data, error } = await supabase
    .from("image_hotspots")
    .select("*")
    .eq("scope", scope)
    .eq("scope_id", scopeId)
    .order("sort_order", { ascending: true })
    .order("created_at", { ascending: true });

  if (error) {
    throw new Error(error.message);
  }

  return (data ?? []) as PublicImageHotspot[];
}
